import styled from 'styled-components';

import { mediaQueryDesktopMin, mediaQueryLaptopMin } from 'styles';

export const Wrapper = styled.footer`
  max-width: 100%;
  width: 100%;

  @media ${mediaQueryDesktopMin} {
    max-width: 742px;
  }

  @media ${mediaQueryLaptopMin} {
    margin-top: 16px;
    width: calc(100% - 325px);
  }
`;
